<label class="active" *ngIf="label && leftAlignLabel">{{ label }}</label>
<div class="input-field" [class.invalid]="hasError">
    <label class="active"
           *ngIf="label && !leftAlignLabel">{{ label }}
    </label>
    <textarea [(ngModel)]="value"
              [placeholder]="placeholder"
              [disabled]="isDisabled"
              [maxlength]="maxLength">
    </textarea>
    <app-form-error-list *ngIf="showErrors"
                         [errorMap]="formControl.errors"></app-form-error-list>
</div>
